import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule, Routes } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { AuthService } from '../../appServices/AuthService/auth.service';
import { ToastModule } from 'primeng/toast';

import { HeaderComponent } from 'src/app/appWeb/layout/header/header.component';
import { SideBarComponent } from 'src/app/appWeb/layout/side-bar/side-bar.component';
import { ViewDefineComponent } from 'src/app/appWeb/layout/view-define/view-define.component';
import { BodyComponent } from 'src/app/appWeb/layout/body/body.component';
import { SharedModule } from '../shared/shared.module';

// Material
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatRippleModule } from '@angular/material/core';
import { PanelMenuModule } from 'primeng/panelmenu';
import { InputTextModule } from 'primeng/inputtext';

// PrimeNg
import { TieredMenuModule } from 'primeng/tieredmenu';
import { AvatarModule } from 'primeng/avatar';
import { FooterComponent } from './footer/footer.component';
import { Modules, SubMenues } from 'src/app/appCommon/Enums/enum';
import { ChartModule } from 'primeng/chart';
import { ErrorPageComponent } from '../pages/static-pages/components/error-page/error-page.component';
import { caseInsensitiveMatcher } from 'src/app/appCommon/Pipes/LowerCaseUrlSerializer';

const routes: Routes = [
  {
    path: '',
    component: ViewDefineComponent,
    children: [
     
      { path: '', loadChildren:()=>import('src/app/appWeb/pages/define/define.module').then(l=>l.DefineModule)},
      {path:Modules.Define,loadChildren:()=>import('src/app/appWeb/pages/define/define.module').then(l=>l.DefineModule)},
      {path:Modules.SettingsModule,loadChildren:()=>import('src/app/appWeb/pages/settings/settings.module').then(l=>l.SettingsModule)},
      {path:Modules.Analyze,loadChildren:()=>import('src/app/appWeb/pages/analyze/analyze.module').then(a=>a.AnalyzeModule)},
      {path:Modules.Measures,loadChildren:()=>import('src/app/appWeb/pages/measures/measures.module').then(m=>m.MeasuresModule)},
      {path:Modules.Improve,loadChildren:()=>import('src/app/appWeb/pages/improve/improve.module').then(m=>m.ImproveModule)},
      {path:Modules.Control,loadChildren:()=>import('src/app/appWeb/pages/control/control.module').then(m=>m.ControlModule)},
      {path:Modules.StaticPages,loadChildren:()=>import('src/app/appWeb/pages/static-pages/static-pages.module').then(m=>m.StaticPagesModule)},
      {path :'**',component: ErrorPageComponent}
    ],
  }
];

@NgModule({
  declarations: [
    HeaderComponent,
    SideBarComponent,
    ViewDefineComponent,
    BodyComponent,
    FooterComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    ButtonModule,
    FormsModule,
    HttpClientModule,
    ToastModule,
    MatSidenavModule,
    MatTooltipModule,
    MatMenuModule,
    MatRippleModule,
    PanelMenuModule,
    InputTextModule,
    TieredMenuModule,
    AvatarModule,
    ChartModule,
    SharedModule 
  ],
  providers: [AuthService],
})
export class LayoutModule {}
